import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToStr',
  pure: false
})
export class ArrayToStrPipe implements PipeTransform {
  transform(value: any[]): string {
    if (!value || value.length === 0) {
      return '';
    }

    let result = '';
    const lastIndex = value.length - 1;

    value.forEach((item, index) => {
      result += item.employee_name;
      if (index !== lastIndex) {
        result += ', ';
      }
    });

    return result;
  }
}
